import { render, staticRenderFns } from "./CostInfo.vue?vue&type=template&id=5740e920&"
import script from "./CostInfo.vue?vue&type=script&lang=js&"
export * from "./CostInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports